import { INPUTS_VALIDATORS_STRATEGIES } from "@puls/puls-common-constants"
import { inputValidators } from "@puls/puls-general-utils"
import { helpers } from "@vuelidate/validators"

export const getCommunicationType = (communication: string): string => {
	if (inputValidators[INPUTS_VALIDATORS_STRATEGIES.PHONE_DIGITS_ONLY](communication)) {
		return INPUTS_VALIDATORS_STRATEGIES.PHONE
	}

	if (inputValidators[INPUTS_VALIDATORS_STRATEGIES.EMAIL](communication)) { 
		return INPUTS_VALIDATORS_STRATEGIES.EMAIL;
	}

	return '';
}

export const validateCommunication = (communication: string): boolean => {
	const communicationType = getCommunicationType(communication);
	return !helpers.req(communication) || !!communicationType
}
